// @ts-nocheck
/* eslint-disable */
export const appChevronUp16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14,11L8,5.5L2,11" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'chevron-up-16' as const
};